import { Square2StackIcon } from "@heroicons/react/24/outline";

export const SectionHeader = (props) => {

  // input
  const {
    title = null
  } = props;

  return (
    <h1 className="text-2xl text-secondary-700 font-semibold">{title}</h1>
  );
};
